var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIntegration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4004 6.50078C21.2004 7.30078 21.2004 8.60078 20.4004 9.30078L17.6004 12.1008L9.80039 4.30078L12.6004 1.50078C13.4004 0.700781 14.7004 0.700781 15.4004 1.50078L17.2004 3.30078L20.2004 0.300781L21.6004 1.70078L18.6004 4.70078L20.4004 6.50078ZM14.6004 12.3008L13.2004 10.9008L10.4004 13.7008L8.30039 11.6008L11.1004 8.80078L9.70039 7.40078L6.90039 10.2008L5.40039 8.80078L2.60039 11.6008C1.80039 12.4008 1.80039 13.7008 2.60039 14.4008L4.40039 16.2008L0.400391 20.2008L1.80039 21.6008L5.80039 17.6008L7.60039 19.4008C8.40039 20.2008 9.70039 20.2008 10.4004 19.4008L13.2004 16.6008L11.8004 15.2008L14.6004 12.3008Z",
    fill: "#515253"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegration);
export default __webpack_public_path__ + "static/media/integration.cc203ea82819b04980207cf94781f887.svg";
export { ForwardRef as ReactComponent };